import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import PropTypes from 'prop-types';
import useCldrDataReducer from '../useCldrDataReducer';
import likelySubtags from './cldr/likelySubtags.json';
import numberingSystems from './cldr/numberingSystems.json';
import plurals from './cldr/plurals.json';
import ordinals from './cldr/ordinals.json';
import currencyData from './cldr/currencyData.json';
import timeData from './cldr/timeData.json';
import weekData from './cldr/weekData.json';
/**
 * CldrSupplementals
 */

function CldrSupplementals(_ref) {
  var children = _ref.children,
      disableCurrency = _ref.disableCurrency,
      disableDate = _ref.disableDate,
      disableNumber = _ref.disableNumber,
      disablePlural = _ref.disablePlural,
      disableRelativeTime = _ref.disableRelativeTime,
      disableTerritories = _ref.disableTerritories,
      disableUnits = _ref.disableUnits;
  var result = useCldrDataReducer(useCldrDataReducer.TYPE_SUPPLEMENTAL, {
    currencyData: currencyData,
    numberingSystems: numberingSystems,
    plurals: plurals,
    ordinals: ordinals,
    timeData: timeData,
    weekData: weekData
  }, {
    disableCurrency: disableCurrency,
    disableDate: disableDate,
    disableNumber: disableNumber,
    disablePlural: disablePlural,
    disableRelativeTime: disableRelativeTime,
    disableUnits: disableUnits,
    disableTerritories: disableTerritories
  });
  return children([likelySubtags].concat(_toConsumableArray(result)));
}

CldrSupplementals.propTypes = {
  children: PropTypes.func.isRequired,
  disableCurrency: PropTypes.bool,
  disableDate: PropTypes.bool,
  disableNumber: PropTypes.bool,
  disablePlural: PropTypes.bool,
  disableRelativeTime: PropTypes.bool,
  disableTerritories: PropTypes.bool,
  disableUnits: PropTypes.bool
};
CldrSupplementals.defaultProps = {
  disableCurrency: false,
  disableDate: false,
  disableNumber: false,
  disablePlural: false,
  disableRelativeTime: true,
  disableTerritories: false,
  disableUnits: false
};
export default CldrSupplementals;